<template>
  <div>
    <div class="dovemed-card">
      <h3 class="card-title">Medical Directory</h3>
      <div class="search-container w-100">
        <form @submit.prevent="" class="w-100 d-flex align-items-center searchContainer">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="getDoctors" class="cp ml-3" />
          <input type="search" class="search-input-state w-100 fw700 hide-in-mobile" placeholder="Search physician, hospital, clinic, etc..." v-model="searchName" @input="callDebounce" />
          <input type="search" class="search-input-state w-100 fw700 show-in-mobile" placeholder="Search physician, hospital, etc..." v-model="searchName" @input="callDebounce" />
          <a-icon v-if="searchName" class="close-icon" type="close" :size="'large'" @click="handleClearSearch" />
        </form>
      </div>

      <div class="results-count">
        <div class="result" @click="$router.push({ name: 'ProviderSearch', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Physicians</p>
            <p class="type-count">{{ PhyCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div>

        <!-- Practice Providers -->
        <div class="result" @click="$router.push({ name: 'PracticeSearch', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Practice Providers</p>
            <p class="type-count">{{ HcpCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div>

        <!-- Hospitals -->
        <div class="result" @click="$router.push({ name: 'HospitalSearch', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Hospitals</p>
            <p class="type-count">{{ HospitalCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div>

        <!-- clinics -->
        <div class="result" @click="$router.push({ name: 'ClinicSearch', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Clinics</p>
            <p class="type-count">{{ ClinicCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div>

        <!-- Nfp  -->
        <div class="result" @click="$router.push({ name: 'NFPSearch', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Non-For-Profits</p>
            <p class="type-count">{{ NfpCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div>

        <!--   Bussiness -->
        <!-- <div class="result" @click="$router.push({ name: 'BusinessDirectory', params: { search: searchName, location: location, payloadloc: payloadloc } })">
          <div class="result-name">
            <p class="type">Businesses</p>
            <p class="type-count">{{ BussinessCount }}</p>
          </div>
          <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
        </div> -->
      </div>
    </div>

    <SearchOnMapComponent :search="searchName" />

    <div class="location-result">
      <div>
        <span class="result-for"> Results {{ Mylocation.state ? "for" : "" }} </span>
        <span class="location-name">
          <!-- {{ this.location.city ? this.location.city : "" }} ,
          {{ this.location.state ? this.location.state : "" }} -->
          {{ Mylocation.village ? Mylocation.village : "" }}
          {{ Mylocation.village ? "," : "" }}
          {{ Mylocation.state ? Mylocation.state : "" }}
          {{ Mylocation.country ? "," : "" }}
          {{ Mylocation.country ? Mylocation.country : "" }}
        </span>
      </div>
      <div class="map-location cp" @click="() => locatorButtonPressed(true)">
        <font-awesome-icon size="1x" :style="{ color: getPrimaryColor() }" :icon="['fal', 'map-marker-alt']" />
        <span class="precise-loc" :style="{ color: getPrimaryColor() }"> Use Precise Location </span>
      </div>
    </div>

    <div class="results-container">
      <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Physicians near you</h4>
        <PhysicianCard :setPhyCount="setPhyCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div>

      <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Advanced Practice Providers near you</h4>
        <HcpCard :setHcpCount="setHcpCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div>

      <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Hospitals near you</h4>
        <HospitalCard :setHospitalCount="setHospitalCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div>

      <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Clinics near you</h4>
        <ClinicCard :setClinicCount="setClinicCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div>

      <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Non-For-Profits near you</h4>
        <NfpCard :setNfpCount="setNfpCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div>

      <!-- <div class="phy-card" v-if="!loading">
        <h4 class="phy-title">Businesses near you</h4>
        <BusinessCard :SetBusinessCount="SetBusinessCount" :searchName="searchName" :location="location" :payloadloc="payloadloc" />
      </div> -->

      <div v-if="loading" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>

    <LocationErrorMessage ref="LocationErrorMessageModal" />
  </div>
</template>

<script>
import SearchOnMapComponent from "../../commons/SearchOnMapComponent.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import Repository from "../../../repositories/Repository"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
import HcpCard from "./HcpCard.vue"
import HospitalCard from "./HospitalCard.vue"
import ClinicCard from "./ClinicCard.vue"
import PhysicianCard from "./PhysicianCard.vue"
import NfpCard from "./NfpCard.vue"
import BusinessCard from "./BusinessCard.vue"
import medicalDirectoryRepository from "../../../repositories/medicalDirectoryRepository"
import LocationErrorMessage from "../../Modals/LocationErrorMessage.vue"
import axios from "axios"

library.add(faMapMarkerAlt)

export default {
  name: "MedicalDirectory",
  components: {
    SearchOnMapComponent,
    PhysicianCard,
    HcpCard,
    HospitalCard,
    ClinicCard,
    NfpCard,
    BusinessCard,
    LocationErrorMessage,
  },
  data() {
    return {
      searchName: undefined,
      PhyCount: 0,
      HospitalCount: 0,
      ClinicCount: 0,
      NfpCount: 0,
      HcpCount: 0,
      BussinessCount: 0,
      location: {
        lat: undefined,
        lng: undefined,
      },
      payloadloc: {
        lat: undefined,
        lng: undefined,
      },
      searchFirstName: undefined,
      DoctorsList: [],
      loading: true,
      // loading: false,
      Mylocation: {
        village: undefined,
        state_district: undefined,
        county: undefined,
        state: undefined,
        country: undefined,
      },
    }
  },
  mounted() {
    console.warn("MedicalDirectory.vue is mounted")
    // console.log(this.authUser);
    this.locatorButtonPressed(false)
    // this.location = this.authUser.user.location[0];
    this.getDoctors()
  },
  methods: {
    callDebounce: _.debounce(function() {
      this.getDoctors()
    }, 500),

    // handleSearchInput(e) {
    //   this.searchName = e.target.value
    // },
    handleClearSearch() {
      this.searchName = ""
      this.getDoctors()
    },
    setPhyCount(count) {
      this.PhyCount = count
      // console.log(this.PhyCount);
    },
    setHospitalCount(count) {
      this.HospitalCount = count
      // console.log(this.HospitalCount);
    },
    setClinicCount(count) {
      this.ClinicCount = count
    },
    setNfpCount(count) {
      this.NfpCount = count
    },
    setHcpCount(count) {
      this.HcpCount = count
    },
    SetBusinessCount(count) {
      this.BussinessCount = count
    },
    async getDoctors(name) {
      console.log("medDir - getDoctors() is called")
      // if (page !== "page") {
      //   this.nextPage = 1;
      // }
      // this.loading = true
      let page = 0
      this.searchFirstName = name ? name : undefined
      document.body.scrollTop = 0
      // console.log("ProviderDirectory -> getDoctors()");
      // this.loading = true;
      // const payload = {}
      // payload.circle_id = this.currentCircle.id
      // if (this.searchFirstName) {
      //   payload.searchFirstName = this.searchFirstName // commented .trim()
      // }

      // let first = payload.searchFirstName ? `&first_name=${payload.searchFirstName}` : ""
      // let url = `${process.env.BASE_API_URL}/doctorsearch/?is_active_physician=true&circle_id=${this.currentCircle.id} ` + first
      // Repository.get(url)
      //   .then(result => {
      //     this.loading = false
      //     this.phyCount = result.data.total_hits
      //     this.DoctorsList = result.data.results.slice(0, 3)
      //     this.setPhyCount(this.phyCount)
      //   })
      //   .catch(err => {
      //     this.loading = false
      //   })
    },
    async locatorButtonPressed(precise_loc = false) {
      console.log("locatorButtonPressed() is called")
      // this.loading = true
      navigator.geolocation.getCurrentPosition(
        position => {
          if (precise_loc) {
            this.$notification.success({ message: "Success", description: "Precise Location is being calculated..." })
          }
          if (position.coords.latitude && position.coords.longitude) {
            const locationpayload = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }
            this.payloadloc.lat = Number(position.coords.latitude)
            this.payloadloc.lng = Number(position.coords.longitude)
            this.loading = true
            medicalDirectoryRepository
              .geolocationSearch(locationpayload)
              .then(res => {
                this.Mylocation.county = res.data.data.address.county
                this.Mylocation.village = res.data.data.address.village
                this.Mylocation.state_district = res.data.data.address.state_district
                this.Mylocation.state = res.data.data.address.state
                this.Mylocation.country = res.data.data.address.country
                // if (precise_loc) {
                //   this.location.lat = Number(res.data.data.lat)
                //   this.location.lng = Number(res.data.data.lon)
                // } else {
                //   this.payloadloc.lat = Number(res.data.data.lat)
                //   this.payloadloc.lng = Number(res.data.data.lon)
                // }
                this.loading = false
              })
              .catch(async err => {
                const locationResponse = await axios.post(`${process.env.SSO_BASE_URL}/api/v2/utils/geolocation/`)
                this.Mylocation.state = locationResponse.data.location_name || ""
                this.loading = false
              })
          } else {
            this.loading = false
          }
        },
        async error => {
          if (precise_loc) {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                // this.$notification.error({ message: "Error", description: "User denied the request for Geolocation." })
                this.$refs.LocationErrorMessageModal.show()
                break
              case error.POSITION_UNAVAILABLE:
                this.$notification.error({ message: "Error", description: "Location information is unavailable." })
                break
              case error.TIMEOUT:
                this.$notification.error({ message: "Error", description: "The request to get user location timed out." })
                break
              case error.UNKNOWN_ERROR:
                this.$notification.error({ message: "Error", description: "An unknown error occurred." })
                break
            }
          } else {
            try {
              this.loading = true
              const locationResponse = await axios.post(`${process.env.SSO_BASE_URL}/api/v2/utils/geolocation/`)
              // console.log("locationResponse.data:", locationResponse.data)
              this.payloadloc = { ...this.payloadloc, lat: locationResponse.data.lat, lng: locationResponse.data.lng }
              this.Mylocation.state = locationResponse.data.location_name || ""
              const myLocationResponse = await medicalDirectoryRepository.geolocationSearch({ latitude: locationResponse.data.lat, longitude: locationResponse.data.lng })
              // console.log("myLocationResponse.data:", myLocationResponse.data)
              this.Mylocation.county = myLocationResponse.data.data.address.county
              this.Mylocation.village = myLocationResponse.data.data.address.village
              this.Mylocation.state_district = myLocationResponse.data.data.address.state_district
              this.Mylocation.state = myLocationResponse.data.data.address.state
              this.Mylocation.country = myLocationResponse.data.data.address.country
              // console.log("My Location:", this.Mylocation)
              this.loading = false
            } catch (e) {
              this.loading = false
            }
          }
          this.loading = false
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 427px) {
  .clear-filter {
    display: none !important;
  }
  .apply {
    margin-bottom: 0px !important;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734 !important;
    display: block !important;
  }
  .search-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    max-width: 100% !important;
  }
  .search-container {
    flex-direction: column;
  }

  .search-input-state {
    margin-bottom: 0px !important;
  }
  .results-count {
    display: none !important;
  }
}

.location-result {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  gap: 24px;
  background: #f1f5f9;
  border-radius: 8px;
  justify-content: space-between;
  margin-top: 48px;
  .result-for {
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #0f1734;
  }
  .location-name {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734;
  }

  .map-location {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 4px;

    .precise-loc {
      font-family: "Lato";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      text-transform: capitalize;
    }
  }
}
.dovemed-card {
  margin-bottom: 48px !important;
  @media screen and (max-width: 427px) {
    margin: 0 -16px;
  }
}

.results-count {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 24px;

  .result {
    display: flex;
    cursor: pointer;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    gap: 8px;
    width: 240.67px;
    height: 58px;

    background: #ffffff;

    border: 1px solid #e2e8f0;
    border-radius: 6px;

    .result-name {
      p {
        margin-bottom: 0px;
      }

      .type {
        font-family: "Lato";
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #47556e;
      }
      .type-count {
        font-family: "Lato";
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 10px;
        text-transform: capitalize;

        color: #47556e;
      }
    }
  }
}

.phy-card {
  margin-top: 48px;
  .phy-title {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #0f1734;
  }
}

.phy-pagination-container {
  .pagination-btn {
    padding: 8px;
    gap: 4px;
    width: 790px;
    height: 46px;
    background: #f1f5f9;
    border-radius: 8px;
    border: none;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}

.apply {
  display: none;
}
.card-title {
  text-transform: capitalize;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  text-align: start;
  margin: 0;
  margin-bottom: 24px;
}

.search-container {
  display: flex;
  gap: 24px;
  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    // min-width: 350px;
    width: 50%;
    &:focus {
      outline: none;
    }
  }

  .search-input-state {
    border-left: 0 !important;
    border-radius: 8px;
    padding: 10px;
    // width: 350px;
    width: 50%;
    &:focus {
      outline: none;
    }
  }

  .search-button {
    width: 60px;
    height: 60px;
    background: #f1f5f9;
    padding: 8px;
    gap: 16px;
    border-radius: 8px;
    border: none !important;
  }
}

.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;
  height: 60px;

  input {
    border: none !important;
    background-color: #f1f5f9 !important;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/MedicalDirectories/MedicalDirectory.vue